<template>
  <div >
    <a-table
      ref="table"
      size="middle"
      :scroll="{x:true}"
      rowKey="id"
      :columns="columns"
      :pagination="false"
      :dataSource="dataSource"
      class="j-table-force-nowrap">

    </a-table>
  </div>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import {filterDictTextByCache} from '@/components/dict/JDictSelectUtil'
  export default {
    name: 'PlatformInfoTable',
    mixins:[JeecgListMixin, mixinDevice],
    components: {},
    props:{
      model:{
        type:Object,
        default: {}
      }
    },
    data() {
      return {
        dataSource:[],
        disableMixinCreated:true,
        columns: [
          {
            title: '所属平台',
            dataIndex: 'platformName',
            align:"center",
            scopedSlots: { customRender: 'platformNameSlot' },

          },{
            title: '当前状态',
            dataIndex: 'currentStatus_dictText',
            align:"center",
            customRender:function (t,r,index) {
              return t || '-';
            }
          },{
            title: '备注',
            dataIndex: 'remark',
            align:"center",
            customRender:function (t,r,index) {
              return t || '-';
            }
          },{
            title: '识别号',
            dataIndex: 'identificationNumber',
            align:"center",
            key: 'identificationNumber',
            customRender:function (t,r,index) {
              return t || '-';
            }
          },{
            title: '所属车队',
            dataIndex: 'teamName',
            align:"center",
            key: 'teamName',
            customRender:function (t,r,index) {
              return t || '-';
            }
          },{
            title: '所属队长',
            dataIndex: 'realname',
            align:"center",
            key: 'realname',
            customRender:function (t,r,index) {
              return t || '-';
            }
          },{
            title: '首次注册时间',
            dataIndex: 'regTime',
            align:"center",
            key: 'regTime',
            customRender:function (t,r,index) {
              return t || '-';
            }
          },
          {
            title: '操作人',
            align:"center",
            dataIndex: 'createByName',
            customRender:function (t,r,index) {
              return t || '-';
            }
          },
          {
            title: '操作时间',
            align:"center",
            dataIndex: 'bdTime',
            customRender:function (t,r,index) {
              return t || '-';
            }
          }
        ]
      }
    },methods:{
     init(){
        this.formatModel();
      },formatModel(){
       let md = {
         ...this.model
       }
       if(md.currentStatus){
         md.currentStatus_dictText =  filterDictTextByCache("current_status",md.currentStatus);
       }

        this.dataSource = [md];
        console.log("this.dataSource",this.dataSource);
      }
    }
  }
</script>
<style lang="less" scoped>
@import '~@assets/less/common.less';
@import '~@assets/less/dm/tableList.less';
@import '~@assets/less/dm/newTable.less';
</style>